import { Button } from 'components'
import Dropdown from 'components/Dropdown/Dropdown'
import EmployeeSelect from 'hooks/EmployeeSelect/EmployeeSelect'
import PositionSelect from 'hooks/PositionSelect/PositionSelect'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
  GetPositionOfStructure,
  createEmpToStructure,
} from 'service/StructureService'
import {
  setNewEmp,
  setPositionOfStructureById,
} from 'store/slices/StructureSlice'
import Notification from 'utils/Notifications'
import styles from './AddEmpForm.module.scss'
import { ScaleLoader } from "react-spinners";


const AddNewEmp = ({ structure_name, id, render, setRender }) => {
  const { t } = useTranslation('common')
  const [loader, setLoader] = useState(false);
  const [id2, setId2] = useState('')
  const [id3, setId3] = useState('')

  const [type_doc, setType_doc] = useState('')
  const request_type = [
    { id: 0, label: t('forms.addNewEmp.staff_type_main') },
    { id: 1, label: t('forms.addNewEmp.staff_type_combination') },
  ]
  const request_type2 = [
    { id: 0, label: '0.25' },
    { id: 1, label: '0.5' },
    { id: 2, label: '1' },
    { id: 3, label: '1.5' },
  ]
  const [employee, setEmployee] = useState('')
  const [bet, setBet] = useState('')
  const [stateName, setStateName] = useState('')
  const [data, setData] = useState()
  const [date_come, setDateCome] = useState()
  const [date_leave, setDateLeave] = useState()
  const dispatch = useDispatch()
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })

  const getData = async () => {
    try {
      const response = await GetPositionOfStructure(structure_name, id, data)
      dispatch(
        setPositionOfStructureById({
          structure_positions: response.data,
        }),
      )
    } catch (error) {
    }
  }

  useEffect(() => {
    getData()
    setRender(false)
  }, [render])

  const positions = useSelector((state) => state.structure.structure_positions)

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (employee === '') {
      setNotify({
        isOpen: true,
        message: t('forms.addNewEmp.no_employee_selected'),
        type: 'warning',
        sound: 'warning',
      })
    } else if (stateName === '') {
      setNotify({
        isOpen: true,
        message: t('forms.addNewEmp.no_position_selected'),
        type: 'warning',
        sound: 'warning',
      })
    } else if (type_doc === '') {
      setNotify({
        isOpen: true,
        message: t('forms.addNewEmp.no_staff_selected'),
        type: 'warning',
        sound: 'warning',
      })
    } else if (bet === '') {
      setNotify({
        isOpen: true,
        message: t('forms.addNewEmp.no_rate_selected'),
        type: 'warning',
        sound: 'warning',
      })

    }else if (date_come === undefined) {
      setNotify({
        isOpen: true,
        message: t('forms.addNewEmp.no_contract_term'),
        type: 'warning',
        sound: 'warning',
      })

    }else if (date_leave === undefined) {
      setNotify({
        isOpen: true,
        message: t('forms.addNewEmp.no_contract_term'),
        type: 'warning',
        sound: 'warning',
      })

    } else
      try {
        setLoader(true);
        let mov_employee_id = employee
        let post = stateName.id
        let state = type_doc
        let stavka = bet
        let date_of_come = date_come
        let date_of_leave = date_leave
        await createEmpToStructure(structure_name, id, {
          mov_employee_id,
          post,
          state,
          stavka,
          date_of_come,
          date_of_leave,
        })
        dispatch(
          setNewEmp({
            mov_employee_id: employee,
            post,
            state,
            stavka,
            date_of_come,
            date_of_leave,
          }),
        )

        setNotify({
          isOpen: true,
          message: t('forms.addNewEmp.employee_added_success'),
          type: 'success',
          sound: 'success',
        })

        setRender(true)
      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: 'error',
          sound: 'error',
        })
      } finally {
        setLoader(false);
      }
  }

  return (
    <div>
      <div className={styles.flex_col}>
        <div className={styles.div__selection}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <h4 >{t('forms.addNewEmp.employee_label')}</h4>
            <EmployeeSelect selectedEmployee={setEmployee} />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <h4 >{t('forms.addNewEmp.position_label')}</h4>
            <PositionSelect
              dataPosition={positions}
              setDataPosition={setStateName}
            />
          </div>
        </div>
        <div className={styles.div__selection}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '50%',

            }}
          >
            <h4>{t('forms.addNewEmp.rate_label')}</h4>
            <Dropdown
              setId={setId2}
              setType={setBet}
              title={t('forms.addNewEmp.select_rate_title')}
              data={request_type2 ?? []}
            />
          </div>

          <div
            style={{ display: 'flex', flexDirection: 'column', width: '50%' }}
          >
            <h4>{t('forms.addNewEmp.staff_label')}</h4>
            <Dropdown
              setId={setId3}
              setType={setType_doc}
              title={t('forms.addNewEmp.select_staff_title')}

              data={request_type ?? []}
            />
          </div>
        </div>
        <div className={styles.div__selection}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '50%',

            }}
          >
            <h4>{t('forms.addNewEmp.contract_from')}</h4>
            <input
            id="date_come"
            name="date_come"
            type="date"
            value={date_come}
            required="required"
            onChange={(e) => setDateCome(e.target.value)}
            className={styles.date_input}
          />
          </div>

          <div
            style={{ display: 'flex', flexDirection: 'column', width: '50%' }}
          >
            <h4>{t('forms.addNewEmp.contract_to')}</h4>
            <input
            id="date_leave"
            name="date_leave"
            type="date"
            value={date_leave}
            required="required"
            onChange={(e) => setDateLeave(e.target.value)}
            className={styles.date_input}
          />
          </div>  </div>
      </div>
      {loader ? (
        <ScaleLoader color="black" size={30} />
      ) : (
        <Button className={styles.add_pos} onClick={handleSubmit}>
          {t('common.add')}{' '}
        </Button>
      )}

      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default AddNewEmp
